module.exports = __webpack_public_path__ + "static/media/reactImage1.358867a2.PNG";